export enum BannerLocation {
  SEGMENT_1 = 0,
  SEGMENT_2 = 1,
}

export type Banner = {
  _id: string;
  desktop: string;
  mobile: string;
  title: string;
  link: string;
  location: BannerLocation;
};
